import type {CanvasChatMessage} from '@/pages/canvas/canvas-types';

export interface ChatTaskShortcut {messageId:string;label:string;taskType:string;status:string;completed:boolean}
export const chatTaskAnchorId = (messageId:string) => `chat-task-${messageId}`;

/** Only structured run context names a product. Legacy cards keep their task name. */
export function chatTaskShortcuts(messages:CanvasChatMessage[]):ChatTaskShortcut[]{
  const runs=new Map<string,ChatTaskShortcut & {productName?:string;priority:number}>();
  for(const message of messages){
    const progress=message.playbookProgress??(message.conceptsRun?{
      playbookName:'Planning ad angles', productName:message.conceptsRun.productName,
      workflowRunId:undefined,phaseStatuses:{},qaResults:[],isDone:message.conceptsRun.status==='ready',
    }:undefined);
    if(message.role!=='assistant'||!progress||message.content?.includes('paused_at_checkpoint')||message.content?.includes('[Orchestrator workflow executed]'))continue;
    const key=progress.workflowRunId!=null?`run-${progress.workflowRunId}`:message.id;
    const previous=runs.get(key);
    const productName=progress.productName?.trim() || previous?.productName;
    const taskType=progress.playbookName?.trim()||'Campaign';
    const qa=new Map((progress.qaResults??[]).map(result=>[result.conceptIndex,result.status]));
    const needsAttention=['failed','interrupted'].includes(message.conceptsRun?.status??'') || Object.values(progress.phaseStatuses??{}).includes('failed')
      || Array.from(qa.values()).includes('needs_review')
      || ['paused','confirming','error','cancelled'].includes(message.workflowState?.status??'');
    const completed=progress.isDone&&!needsAttention;
    const isLive=message.isStreaming===true;
    const status=needsAttention?'Needs attention':completed?'Completed':isLive?'In progress':'Status unavailable';
    runs.set(key,{messageId:previous?.messageId??message.id,label:productName||taskType,productName,taskType,status,completed,priority:needsAttention?0:isLive&&!completed?1:completed?3:2});
  }
  return Array.from(runs.values()).sort((a,b)=>a.priority-b.priority).map(({productName,priority,...task})=>task);
}
